import { lightTheme as light, darkTheme as dark } from '@clds/themes';
import type { ThemeName, User } from '@cld/unicorn-api';
import type { StyledComponentsThemeObject, SystemTheme } from '../types';

export const pickInitialTheme = ({
  systemTheme,
  enableTheming,
  userTheme,
}: {
  systemTheme: SystemTheme;
  enableTheming: boolean;
  userTheme: User['userTheme'];
}): { name: ThemeName; styledComponentsThemeObject: StyledComponentsThemeObject } => {
  // FIXME: remove enableTheming in the future once darkmode is fully supported
  if (enableTheming) {
    if (userTheme === null || userTheme === 'system') {
      return {
        name: systemTheme === 'dark' ? 'dark' : 'light',
        styledComponentsThemeObject: systemTheme === 'dark' ? dark : light,
      };
    }

    return {
      name: userTheme,
      styledComponentsThemeObject: userTheme === 'dark' ? dark : light,
    };
  }

  return {
    name: 'light',
    styledComponentsThemeObject: light,
  };
};
